import { render, staticRenderFns } from "./tezheng.vue?vue&type=template&id=11cc461c&scoped=true"
import script from "./tezheng.vue?vue&type=script&lang=js"
export * from "./tezheng.vue?vue&type=script&lang=js"
import style0 from "./tezheng.vue?vue&type=style&index=0&id=11cc461c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11cc461c",
  null
  
)

export default component.exports